import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './source/index';
import NoInternetConnection from './NoInternatemodal';
import { registerTableFilterDropdownFix } from './components/common/helpers/tableFilterDropdownFix';
registerTableFilterDropdownFix();
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
    <NoInternetConnection>
      <Provider store={store}>
        <App />
      </Provider>
    </NoInternetConnection>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
